import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { isAnyOverlayFormVisible } from '../businessLogic/form';
import QuickViewContent from '../components/pages/quick-view/view/content';

const QuickView = (props) => {
  const userHasWaitingAreas = useSelector((state) =>
    state.usersReducer.userProfile.shouldLoadDirectlyAssociatedWAs &&
    state.usersReducer.userProfile.hasEntityAdminRights &&
    state.usersReducer.userProfile.hasEntityAdminRights.isOrgAdmin
      ? state.usersReducer.userProfile.hasDirectlyAssociatedWaitingAreas
      : state.usersReducer.userHasWaitingAreas
  );
  const userHasMeetingRooms = useSelector((state) => state.usersReducer.userHasMeetingRooms);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin);
  const hasEntityAdminRights = useSelector(
    (state) => state.usersReducer.userProfile && state.usersReducer.userProfile.hasEntityAdminRights
  );
  const userHasAdminRights = useSelector((state) => state.usersReducer.userProfile.hasAdminRights);
  const waitingAreas = useSelector((state) => state.waitingAreaReducer.waitingAreas);
  const hideWhenClickAwayQuickView = useSelector((state) => state.modalReducer.hideWhenClickAwayQuickView);
  const showQuickViewModal = useSelector((state) => state.modalReducer.showQuickViewModal);
  const userHasReports = useSelector((state) => state.usersReducer.userProfile.hasReports);
  const canAccessResourceCentre = useSelector(
    (state) =>
      state.usersReducer.userProfile.featuresEnabled && state.usersReducer.userProfile.featuresEnabled.resourceCentre
  );
  const user = useSelector((state) => state.usersReducer.userProfile);
  // const isAnyOtherOverlayFormVisible = isAnyOverlayFormVisible();
  const dispatch = useDispatch();
  const [canSeeEntityAdminPage, setCanSeeEntityAdminPage] = useState(false);
  useEffect(() => {
    if (hasEntityAdminRights != undefined && isAdmin != undefined) {
      // This includes service admin & mr admin
      // canSeeEntityAdminPage =
      //   this.props.hasEntityAdminRights.isOrgAdmin ||
      //   this.props.hasEntityAdminRights.isServiceAdmin ||
      //   this.props.hasEntityAdminRights.isMeetingRoomAdmin ||
      //   this.props.isAdmin;
      // This excludes service admin & mr admin
      setCanSeeEntityAdminPage(hasEntityAdminRights.isOrgAdmin || isAdmin);
    }
  }, [hasEntityAdminRights, isAdmin]);
  return (
    <QuickViewContent
      onClose={props.onClose}
      loggedInUserHandler={props.loggedInUserHandler}
      renderOnMount={props.renderOnMount}
      hideWhenClickAwayQuickView={hideWhenClickAwayQuickView}
      showQuickViewModal={showQuickViewModal}
      userHasWaitingAreas={userHasWaitingAreas}
      canSeeEntityAdminPage={canSeeEntityAdminPage}
      userHasMeetingRooms={userHasMeetingRooms}
      userHasReports={userHasReports}
      userHasAdminRights={userHasAdminRights}
      canAccessResourceCentre={canAccessResourceCentre}
      waitingAreas={waitingAreas}
      user={user}
      isAnyOtherOverlayFormVisible={props.isAnyOtherOverlayFormVisible}
      dispatch={dispatch}
    />
  );
};
function mapStateToProps(state) {
  let isAnyOtherOverlayFormVisible = isAnyOverlayFormVisible();
  return {
    isAnyOtherOverlayFormVisible: isAnyOtherOverlayFormVisible,
  };
}
export default connect(mapStateToProps)(QuickView);
